import React from 'react';
import {Map} from 'immutable';
import {FreeResponseEditor} from './FreeResponseEditor.react';
import {FreeResponseQuestion} from './FreeResponseQuestion.react';
import {FreeResponseExplanation} from './FreeResponseExplanation.react';
/**
 * There are no stats for 'free-response' questions.
 */
const FreeResponseResponseStats = () => {
  return <div />;
};

export const FreeResponseQuestionType = Map({
  type: 'free-response',
  label: 'Free Response',
  questionRenderer: FreeResponseQuestion,
  explanationRenderer: FreeResponseExplanation,
  responseStatsRenderer: FreeResponseResponseStats,
  editor: FreeResponseEditor,
  isHidden: false
});
